<template>
  <div class="page-container">
		<HeaderLayout :pagecode="pagecode" :subpagecode="subpagecode" @eventProblemCode="updateProblemCode"></HeaderLayout>
		<div class="content">
			 <div class="header-box">
				<img src="../../assets/img/img-robo.jpg" width=150 height=150 >
				<div style='width:400px;margin:auto;' v-if="buttonView">
					<p>A.I {{name}}님을 만들어 볼까요?</p>
					<!-- div class="box-text" @click="screenView=true" style='cursor:pointer;'>{{gtypeMessage}}</div -->
					<p class="text">{{processPer}}%</p>
					<div class="box-radius"><span class="box-line" :style="{width:processPer+'%'}"></span></div>
				</div>
				 <div style='width:400px;margin:auto;' v-else>
					 <p>A.I {{name}}님의 아바타가 생성되었습니다</p>
					 <md-button class="md-raised md-primary" style="margin-top:20px"  @click="restartTest()">아바타 재생성</md-button>
				 </div>
			 </div>
		
			  <div class="content-layout">
				<div class="content-layout-box" style='display:flex;' v-if="buttonView">
				   <ul class="data-box">
						<li class="data-item" v-for="data,index in dataList1">
							
							<div v-if="data.bigText" class="bigTextBox">
								<div class="bigTextGuide">{{data.bigTextGuide}}</div>
								<div class="box-content" v-html="data.bigText"></div>
							</div>
							<div class="question">
								<h3 :class="data.result">
									<div class="rotate-line" v-if="data.result=='bad'"></div>
									{{((index+1)<10)?'0'+(index+1):(index+1)}}
								</h3>

								<p class="name">{{data.pbQuestion}}?</p>
							</div>
							<div class="answer-box">
								<div v-if="data.pbType=='s'" class='form-group'>
									
									<ul :class="'box-list '+data.result" >
										<li v-for="item,subIndex in data.answerList" :class="item.gclass" @click="choiceAnswer(index,subIndex)">
											<span class="text-1">{{(subIndex+1)}}</span> {{item.val}}
										</li>
									</ul>
									<div class="md-error-box">답을 입력하세요</div>
								</div>
								<div v-else  class="vAnswer">
									<div v-if="data.result" style='color:#000;font-size:14px;font-weight:bold;'>
									  {{data.uAnswer}} 
									</div>
									<div v-else class='form-group vtype'>   
										<div class="md-field">
											  <input autocomplete="off" type="text" v-model="answerList[parseInt(index)+1]" placeholder="답을 입력하세요"/>
										</div>
										<div class="md-error-box" style='margin-top:-20px;'>답을 입력하세요</div>
									</div>
								</div>
								
							</div>
						</li>
					</ul>
					<ul class="data-box">
						<li class="data-item" v-for="data,index in dataList2">
							
							<div v-if="data.bigText" class="bigTextBox">
								<div class="bigTextGuide">{{data.bigTextGuide}}</div>
								<div class="box-content" v-html="data.bigText"></div>
							</div>
							<div class="question">
								<h3 :class="data.result">
									<div class="rotate-line" v-if="data.result=='bad'"></div>
									{{((dataIndex+index+1)<10)?'0'+(dataIndex+index+1):(dataIndex+index+1)}}
								</h3>

								<p class="name">{{data.pbQuestion}}?</p>
							</div>
							<div class="answer-box">
								<div v-if="data.pbType=='s'" class='form-group'>
									
									<ul :class="'box-list '+data.result" >
										<li v-for="item,subIndex in data.answerList" :class="item.gclass"  @click="choiceAnswer(dataIndex+index,subIndex)">
											<span class="text-1">{{(subIndex+1)}}</span> {{item.val}}
										</li>
									</ul>
									<div class="md-error-box">답을 입력하세요</div>
								</div>
								<div v-else  class="vAnswer">
									<div v-if="data.result" style='color:#000;font-size:14px;font-weight:bold;'>
									  {{data.uAnswer}} 
									</div>
									<div v-else class='form-group vtype'>   
										<div class="md-field">
											 <input autocomplete="off" type="text" v-model="answerList[parseInt(index)+dataIndex+1]" placeholder="답을 입력하세요"/>
										</div>
										<div class="md-error-box" style='margin-top:-20px;'>답을 입력하세요</div>
									</div>
								</div>
								
							</div>
						</li>
					</ul>
				</div>
				<div class="content-layout-box" style='line-height:300px;text-align:center;' v-else>
					<h3>아바타가 생성되었습니다</h3>

				</div>
			</div>
			<div class="button-box">
				<md-button class="md-raised md-primary" @click="completeTest()" v-if="!resultFlag && buttonView">완료</md-button>		
			</div>
		</div>
		
		<div class="screenLayout" v-if="screenView">
			<div class="content-wrapper">
				<div class="content-box">
					<span @click="screenView=false"><i class="fa fa-times" style="cursor:pointer;"></i></span>
					<ul>
						<li v-for="name,gcode in gtypeList" style='cursor:pointer;' @click="choiceGtype(gcode)">{{name}}</li>
					</ul>
				</div>
			</div>
		</div>
		<FooterLayout></FooterLayout>
  </div>
</template>

<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'

export default {
	name: 'MemberMyAI',
	components: {
	  HeaderLayout,
	  FooterLayout,
   },
	data() {
		return {
			gtype:'a',
			cmd:'',
			no:'',
			pagecode:'',
			subpagecode:'ai',
	    	gtypeList:{},
			gtypeMessage:'',
			screenView:false,
			name:'',
			init:true,
			bigTextList:[],
			dataIndex:0,
			dataList:[],
			dataList1:[],
			dataList2:[],
			answerList:{},
			buttonView:true,
			resultFlag:false,
			resultTempFlag:false,
			processPer:0,
			restartCmd:'',
			
		}
	},
	created() {
		this.cmd = this.$route.params.cmd;
		if(this.cmd=='upd')this.pagecode = 'mypage';
		else this.pagecode = '';
		this.getData();
		
		var memberInfo = sessionStorage.getObject('memberInfo');
		this.name = memberInfo.name;
	},
	methods: {
		 updateProblemCode(code) {
		   this.$router.push({path:'/member/memberInfo'});

	    },
		restartTest() {
		 	this.restartCmd='restart'
			this.getData();
		},
		getData() {	
			var obj = this;
			obj.bigTextList = []
			obj.dataList = []
			obj.answerList = {}
			obj.resultFlag = false;
			obj.buttonView = true;
			obj.resultTempFlag = false;
			obj.processPer = 0;
			this.$form.sendPost({cmd:this.cmd,gtype:this.gtype,restartCmd:this.restartCmd},'record/getMyAi',function(resp) {
			//	console.log(resp)
				obj.restartCmd=''
				if(resp.result=='nodata') {
					//obj.$router.go(-1);
					/*
					obj.gtypeList = resp.gtypes;
					obj.gtypeMessage = obj.gtypeList[resp.gtype]; 
					obj.init=false;
					*/
					obj.buttonView = false;
					return;
				} else if(resp.result=='succ') {
					obj.gtypeList = resp.gtypes;
					obj.gtypeMessage = obj.gtypeList[resp.gtype]; 
					
					//console.log(resp.info);
					if(!resp.info.no) {
						//obj.$router.go(-1);
						obj.buttonView = false;
						return;
					}
					obj.no = resp.info.no;
					
					//if(resp.resultAnswers.length>0) {
					//	obj.resultFlag = true;
						//obj.menuText = '내가 푼 문제';
					//} else 
					if(resp.temp_resultAnswers.length>0) {
						obj.resultTempFlag = true;
					}
					obj.initSetting(resp);
				} else {
					obj.buttonView = false;
					return;
				}
			});
	  
	  },
	  initSetting(resp) {
			if(resp.bigtextList.length>0) {
				for(var k in resp.bigtextList) {
					var item  = resp.bigtextList[k];
					var index = this.bigTextList.length+1;
					var item = {code:'A'+index,val:item.summary,gno:item.no,content:item.content,updcontent:item.updcontent}
					this.bigTextList.push(item)
				}
			}
			if(resp.pbList.length>0) {
				for(var k in resp.pbList) {
					var item  = resp.pbList[k];
					var temp_answer = '';
					if(item.pbType=='s') {
						var goodAnswer = '';
						for(var index in item.pbSAnswer) {
							var dataItem = item.pbSAnswer[index];
							if(this.resultFlag) {
								if((parseInt(index)+1)== parseInt(resp.resultAnswers[k].uAnswer)) {
									dataItem.gclass='active';
								} else dataItem.gclass='';
							} else if(this.resultTempFlag) {
								if((parseInt(index)+1)== parseInt(resp.temp_resultAnswers[k].uAnswer)) {
									dataItem.gclass='active';
									temp_answer = resp.temp_resultAnswers[k].uAnswer;
								} else dataItem.gclass='';
							}
							

							if(parseInt(index)+1 == parseInt(item.pbAnswer)) {
								goodAnswer = '('+(parseInt(index)+1)+') '+dataItem.val;
							}
						}
						item.answerString = goodAnswer;
					} else {
						item.answerString = item.pbAnswer;
						if(this.resultTempFlag) {
							temp_answer = resp.temp_resultAnswers[k].uAnswer;
						}			
					}
					if(this.resultFlag) {
						item.uAnswer = resp.resultAnswers[k].uAnswer;
						item.result = resp.resultAnswers[k].result;
					}
					item.answerList=item.pbSAnswer;
					if(this.resultTempFlag) {
						this.answerList[parseInt(k)+1] = temp_answer;
					}
					this.dataList.push(item)
				}
				this.dataReset();
			}
	  },			
	  
	  dataReset() {
			var selectedItems = {};
			for(var k in this.bigTextList) {
				var item = this.bigTextList[k];
				selectedItems[item.gno] = item.content;
			}
			
			var bigTextCode = '';
			var updateIndex = '';
			var usedBigText = {};
			for(var key in this.dataList) {
				var item = this.dataList[key];
				if(item.textRel) {
					if(bigTextCode == item.bigTextCode) {
						var startNum = parseInt(updateIndex)+1;
						var endNum = parseInt(key)+1; 
						this.dataList[updateIndex].bigTextGuide = '('+startNum+'~'+endNum+') 다음 지문을 읽고 물음에 답하시오';
						continue;
					}
					if(!usedBigText[item.bigTextCode]) {
						usedBigText[item.bigTextCode] = true;
						bigTextCode = item.bigTextCode;
						item.bigTextGuide = '다음 지문을 읽고 물음에 답하시오';
						item.bigText = selectedItems[item.bigTextCode];
						updateIndex = key;
					}
				}
			}
			bigTextCode = '';
			usedBigText = {};
			for(var k in this.dataList) {
				var item = this.dataList[k];
				
				if(k < this.dataList.length/2) {
					this.dataList1.push(this.dataList[k]);
					if(!usedBigText[item.bigTextCode]) {
						usedBigText[item.bigTextCode] = true;
						bigTextCode = item.bigTextCode;
					}
				} else {
					if(item.textRel) {
						if(bigTextCode == item.bigTextCode) {
							this.dataList1.push(this.dataList[k]);
						} else {
							this.dataList2.push(this.dataList[k]);	
						}
						
					} else {
						this.dataList2.push(this.dataList[k]);
					}
				}

			}
			this.dataIndex = this.dataList1.length;
	  },
	  choiceAnswer(index,subIndex) {
		   if(this.resultFlag)return;

			for(var key in this.dataList[index].answerList) {
				var item = this.dataList[index].answerList[key];
				if(key == subIndex) {
					item.gclass = 'active';
					
				} else {
					item.gclass = '';
					
				}
				this.$set(this.dataList[index].answerList,key,item);
			}
			//console.log(this.dataList);
			this.answerList[parseInt(index)+1] = parseInt(subIndex)+1;

			var processPer = 0;
			
			for(var k in this.answerList) {
				if(this.answerList[k]) {
					processPer++;
				}

			}
			console.log(processPer,this.dataList.length);
			this.processPer = parseInt(parseFloat(processPer/this.dataList.length) * 100);
			
			$('.form-group').eq(index).removeClass('md-invalid');
			this.$form.sendPost({answers:this.answerList,no:this.no},'problemProc/registTempAiCreate',function(resp) {
				if(resp.result=='succ') {
					//obj.getData();	
				
				}
			});
			

	  },
	  completeTest() {
		var obj = this;
		var checkFlag = true;
		var top = 0;
		$('.form-group').each(function(k) {
			if(checkFlag) {
				if(!obj.answerList[parseInt(k)+1]) {
					$(this).addClass('md-invalid');
					top = $(this).offset().top -300; 
					checkFlag = false;
					return;
				}
			}
	    });
		if(!checkFlag) {
				var positionTop = top+ $('body').scrollTop();
				$('html,body').animate({
					scrollTop:positionTop
				},200);
				
			return;
		}
		var params = {
			no:this.no,
			answers:this.answerList
		}
		var obj = this;
		var alertparams = {}
		alertparams.content = '시험 문제를 제출합니다. 제출 시에는 수정이 불가능합니다.<br>시험 문제를 제출하시겠습니까?';	
		alertparams.cancleView = true;
		alertparams.doAction = function() {
			obj.$form.sendPost(params,'problemProc/registAiCreate',function(resp) {
				if(resp.result=='succ') {
					obj.getData();	
				
				}
			});
		}
		this.$eventBus.$emit('dialogOpen',alertparams);		
		
			  
	  },
	  choiceGtype(gtype) {
		  
		  this.gtype = gtype;
		  this.gtypeMessage = this.gtypeList[gtype]; 
		  if(this.cmd!='upd') {
			this.cmd = gtype;		
		  }
		  this.getData() 
		  this.screenView = false;
	  }

	},
	mounted() {
		if(this.cmd=='upd') {
		  $('.page-container').css('padding-top','160px');
		}
	},
	updated() {
		$('.form-group.vtype input').off('keyup');
		$('.form-group.vtype input').on('keyup',function() {
		
			if($(this).val()) {
				$(this).parent().parent().removeClass('md-invalid');
			}
		});
	}
}
         
</script>
<style lang="scss" scoped>
*    {
     margin:0;
	 padding:0;
}
a    {
     text-decoration:none;
}
li    {
      list-style:none;
}
.md-field {
	input[type="text"] {
		border:none;
		background:#fff;
		border-bottom:solid 1px #ccc;
		width:80%;
		&:focus {
			outline:none;
			border-bottom:solid 1px #222;
		}
	}	
}	
.page-container      {
          width:100%;
		  min-height:calc(100vh);
		  background-color:#E6E8F4;
		  padding-top:120px;
		  .content  {
				width:800px;
				margin:0 auto 60px auto;
				  padding:10px;
				  font-family: 'Nanum Gothic', sans-serif;
				  height:auto;
				.header-box		{
		  		    width:100%;
					height:auto;
					background-color:#fff;
					border-left:solid 1px #ccc;
					border-right:solid 1px #ccc;
					z-index:1000;
					padding:20px 30px ;
					text-align:center;
					font-family: 'Nanum Gothic', sans-serif;
					p			{
					        font-size:15px;
					        color:#667292;
							padding-top:7px;
							font-weight:bold;
					}
					.box-text	  {
							width:100%;
							padding:5px 0;
							text-align:center;
							border:1px solid #AAAAAA;
							border-radius:20px;
					        font-size:12px;
					        color:#000;
							margin-top:15px;
					}
					.text        {
					       float:right;
						   color:#b1b1b1;
						   font-size:13px;
						
					}
					.box-radius      {
						   width:100%;
						   height:6px;
						   background-color:#DCDCDC;
						   margin-top:30px;
						   position:relative;
						   border-radius:5px;
						   .box-line       {
						   			display:inline-block;
									position:absolute;
									left:0;
									width:25%;
									height:6px;
									background:#3D79FF;
									border-radius:5px;
						   }
					 }
					
				  }
				  .button-box {
					width:100%;
					margin-top:10px;
					.md-button {
						width:100%;
						margin:0;
					}
				  }
				  .content-layout{       
						height:auto;
						margin:auto;
						overflow-x:hidden;
						padding:20px 0;
						margin-top:10px;
						font-family: 'Nanum Gothic', sans-serif;
						z-index:10000;
						min-height:400px;
						background:#fff;
						border-left:solid 1px #ccc;
					    border-right:solid 1px #ccc;
						.data-box {
							&:first-child {
								border-right:solid 1px #ccc;
							}
							width:400px;
							padding:20px 40px 0 40px;
							li.data-item {
								padding-bottom:20px;
								font-family: 'Nanum Gothic', sans-serif;
								  h3   {
								  		margin-top:10px;
										font-size:18px;
										color:#3D79FF;
								  }
								  h3.good {
										border:solid 1px #F24A4A;
										width:30px;
										height:30px;
										border-radius:15px;
										padding-top:5px;
										text-align:center;
								  }
								   h3.bad {
								   		position:relative;
										.rotate-line {
											top:-12px;
											left:-15px;
											position:absolute;
											width:30px;
											height:30px;
											border-top:1px solid #F24A4A;
											transform:rotate(130deg);
											-ms-transform:rotate(130deg);
											-webkit-transform:rotate(130deg);
											-moz-transform:rotate(130deg);
											-o-transform:rotate(130deg);
										}
								  }
								  &first-child {
									 h3   {
								  		padding-top:0;
									}
								  	
								  }
								  .name      {
								        font-size:13px;
										color:#000;
										padding-top:4px;
										font-weight:bold;
								  }
								  .bigTextGuide {
									color:#000;
									font-weight:bold;
									font-size:13px;
									padding-bottom:10px;
								  }
								  .box-content        {
								  		border:4px solid #9AB4EE;
										background:#F4F4F4;
										padding:13px 12px;
										font-size:11px;
										word-spacing:-2px;
								  }
								  .box-list        {
								        padding-top:3px;
										margin-bottom:10px;
									    li        {
										  width:100%;
										  margin-top:6px;
										  cursor:pointer;
										  font-size:12px;
										  .text-1      {
												  		   display:inline-block;
														   width:15px;
														   height:15px;
														   border:1px solid #ABABAB;
														   text-align:center;
														   line-height:13px;
														   border-radius:50%;
														   margin-right:3px;
												  }
										}
										li.active    {
											color:#F24A4A;
											.text-1     {
												  border:1px solid #F24A4A;
											}
										}
								  }
								  .box-list.bad  {
								       li  {
											cursor:default;	
									   }
								  }
								  .box-list.good  {
								       li  {
											cursor:default;	
									   }
								  }
							}
										
						}
				  
			  }
		  }
		  
}
     

</style>